import React from 'react'
import { Formik } from 'formik'
import { get } from 'lodash'
import MediaField from '../../MediaChooser/MediaField'
import Panel from '../../Panel'
import RunValidationTrigger from './RunValidationTrigger'
import FieldContainer from '../../FieldContainer'

import { clearExportData } from './utils'

const EditVideoBlock = ({ config, newBlock, onSave, onDelete, onCancel }) => (
  <Panel title="Video">
    <Formik
      initialValues={config}
      validate={validate}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={(values) => onSave(clearExportData(values))}
      render={({
        values,
        errors,
        handleChange,
        setFieldValue,
        validateForm,
        handleSubmit,
      }) => (
        <form onSubmit={handleSubmit}>
          <div className="grid-x grid-margin-x df-md-wrap form-arrow-centered">
            <div className="cell small-12 large-6">
              <div className="material-textfield invisible-select">
                <label htmlFor="videoSource">Video Source</label>
                <select
                  name="videoSource"
                  className="edit-video__select"
                  data-testid="videoSourceField"
                  value={values.videoSource}
                  onChange={handleChange}
                >
                  <option value="vimeo">Vimeo</option>
                  <option value="youtube">YouTube</option>
                </select>
              </div>
            </div>
            <div className="cell small-12 large-6">
              <FieldContainer error={errors.videoId}>
                <label htmlFor="videoId">Video ID</label>
                <input
                  type="text"
                  name="videoId"
                  data-testid="videoIdField"
                  value={values.videoId}
                  onChange={handleChange}
                />
              </FieldContainer>
            </div>
          </div>
          {
            values.videoSource == "youtube" && (
              <label className="container-check-box margin-bottom-1">
                <input
                  type="checkbox"
                  name="enableChat"
                  checked={values.enableChat}
                  onClick={() => setFieldValue('enableChat', !values.enableChat)}
                  onChange={() => {}}
                />
                <span className="checkmark-small" />
                <span>Enable chat for live streaming video (<a href="https://support.google.com/youtube/answer/9528076" target="_blank">not for kids under 13</a>)</span>
              </label>
            )
          }
          <MediaField
            label="Thumbnail Image"
            mediaId={values.thumbnailImageId}
            error={errors.thumbnailImageId}
            exportedFileName={get(values, 'exportData.thumbnailImage')}
            onChange={(imageId) => setFieldValue('thumbnailImageId', imageId)}
          />
          <FieldContainer fieldClasses="invisible-select" error={errors.title}>
            <label htmlFor="title">Title</label>
            <input
              type="text"
              id="title"
              data-testid="titleField"
              value={values.title}
              onChange={handleChange}
            />
          </FieldContainer>
          <div>
            <button
              type="submit"
              data-testid="saveButton"
              onClick={handleSubmit}
              className="bg-green__btn l-margin-right-sm"
            >
              Save Block
            </button>
            <button
              type="submit"
              onClick={onCancel}
              className="bg-gray__btn l-margin-right-sm"
            >
              Cancel
            </button>
            <button
              type="button"
              title="Delete Block"
              onClick={onDelete}
              className="page-editor-edit-form__delete-icon"
            >
              <i className="far fa-trash-alt" />
            </button>
          </div>
          {newBlock ? null : (
            <RunValidationTrigger validateForm={validateForm} />
          )}
        </form>
      )}
    />
  </Panel>
)

const validate = (values) => {
  const errors = {}
  if (!values.videoId) {
    errors.videoId = 'Video ID is required'
  } else if (!values.videoId.match(/^[a-zA-Z0-9\-_]+$/)) {
    errors.videoId =
      'Video ID must only contain letters and numbers. Do not paste the full video URL.'
  }
  if (values.videoSource === 'vimeo' && !values.thumbnailImageId) {
    errors.thumbnailImageId = 'Thumbnail Image is required'
  }
  if (values.videoSource === 'vimeo' && !values.title) {
    errors.title = 'Title is required'
  }
  return errors
}

export default EditVideoBlock
